import { ExecutiveResume } from 'src/app/interfaces/executive-resume';

// Mock de Resumen Ejecutivo. Reemplazar por datos reales cuando exista el endpoint de backend
// (ver el TODO en handover-detail-executive-resume.component.ts).
export const EXECUTIVE_RESUME_MOCK: ExecutiveResume = {
  statusCards: [
    {
      category: 'Arquitectura',
      value: 'Desvío',
      state: 'desvio',
      detail: 'LP 5" +15.7 m vs plan',
    },
    {
      category: 'Cementación',
      value: 'Desvío',
      state: 'desvio',
      detail: '2 de 3 casings',
    },
    {
      category: 'Punzados',
      value: 'Desvío',
      state: 'desvio',
      detail: '−7 etapas · −1.900 m',
    },
    {
      category: 'Fractura',
      value: 'Parcial',
      state: 'parcial',
      detail: 'Arena −20% vs diseño',
    },
  ],
  blocks: [
    {
      key: 'arquitectura',
      title: 'Arquitectura',
      dotColor: 'violet',
      archBar: {
        segments: [
          { label: '9 5/8" @640 m', state: 'ok', flex: 640 },
          { label: '7 5/8" @2.054,5 m', state: 'desvio', flex: 1415 },
          {
            label: '5" @6.950,7 m — Zona de Completación',
            state: 'desvio2',
            flex: 4896,
          },
        ],
        legend: [
          { label: 'Cementación OK — 9 5/8"', state: 'ok' },
          { label: 'Cementación Desvío — 7 5/8"', state: 'desvio' },
          {
            label: 'Cementación Desvío / Zona de completación — 5"',
            state: 'desvio2',
          },
        ],
      },
      table: {
        columns: [
          { label: 'CSG / Liner' },
          { label: 'OD Plan' },
          { label: 'OD Real' },
          { label: 'Grado Plan' },
          { label: 'Grado Real' },
          { label: 'MD Zapato Plan (m)', highlight: true },
          { label: 'MD Zapato Real (m)', highlight: true },
          { label: 'Δ MD (m)' },
          { label: 'Estado' },
          { label: 'Comentario' },
        ],
        rows: [
          [
            { text: 'Surface 9 5/8"', strong: true },
            { text: '9.625' },
            { text: '9.625' },
            { text: 'K-55' },
            { text: 'K-55' },
            { text: '640.0' },
            { text: '640.0' },
            { text: '0.0', delta: 'zero' },
            { badge: { label: 'OK', state: 'ok' } },
            { text: 'Coincide con plan.', muted: true },
          ],
          [
            { text: 'Intermediate 7 5/8"', strong: true },
            { text: '7.625' },
            { text: '7.625' },
            { text: 'P-110' },
            { text: 'P-110 ICY' },
            { text: '2.050.0' },
            { text: '2.054.5' },
            { text: '+4.5', delta: 'pos' },
            { badge: { label: 'OK', state: 'ok' } },
            { text: 'Dentro de tolerancia.', muted: true },
          ],
          [
            { text: 'Production 5"', strong: true },
            { text: '5.000' },
            { text: '5.000' },
            { text: 'P-110' },
            { text: 'P-110 ICY' },
            { text: '6.935.0' },
            { text: '6.950.7' },
            { text: '+15.7', delta: 'neg' },
            { badge: { label: 'Revisar', state: 'revisar' } },
            { text: 'Liner colgado ~16 m más profundo que plan.', muted: true },
          ],
        ],
      },
    },
    {
      key: 'cementacion',
      title: 'Cementación',
      dotColor: 'magenta',
      table: {
        columns: [
          { label: 'Diám. Casing (pulg)' },
          { label: 'TOC Plan (m)', highlight: true },
          { label: 'CBL TOC Real (m)', highlight: true },
          { label: 'Δ TOC (m)' },
          { label: 'P. Final Plan (psi)' },
          { label: 'P. Final Real (psi)' },
          { label: 'Δ Presión (psi)' },
          { label: 'Estado' },
          { label: 'Causa' },
          { label: 'Remediación' },
        ],
        rows: [
          [
            { text: '9.625"', strong: true },
            { text: '0.00' },
            { text: '0.00' },
            { text: '0.00', delta: 'zero' },
            { text: '840.00' },
            { text: '900.00' },
            { text: '+60', delta: 'pos' },
            { badge: { label: 'OK', state: 'ok' } },
            { text: '—', muted: true },
            { text: 'Sin remediación', muted: true },
          ],
          [
            { text: '7.625"', strong: true },
            { text: '440.00' },
            { text: '401.00' },
            { text: '−39', delta: 'neg' },
            { text: '2.331.00' },
            { text: '2.161.00' },
            { text: '−170', delta: 'neg' },
            { badge: { label: 'Desvío', state: 'desvio' } },
            { text: 'Pérdida de circulación', muted: true },
            { pill: 'Top Job' },
          ],
          [
            { text: '5"', strong: true },
            { text: '1.748.25' },
            { text: 'n/e', muted: true },
            { text: 'n/e', muted: true },
            { text: '1.717.00' },
            { text: '5.250.00' },
            { text: '+3.533', delta: 'neg' },
            { badge: { label: 'Desvío', state: 'desvio' } },
            { text: 'Zona sin cemento', muted: true },
            { pill: 'Squeeze — Pendiente' },
          ],
        ],
        footerNote:
          'Squeeze casing 5" · MD Base: 1.748,25 m · Objetivo: Aislación de zona sin cemento · Método: Presión / CBL · Resultado: Pendiente',
      },
    },
    {
      key: 'punzados',
      title: 'Punzados',
      dotColor: 'red',
      table: {
        columns: [
          { label: 'Intervalo Plan (m)' },
          { label: 'Intervalo Real (m)' },
          { label: 'Δ Intervalo (m)' },
          { label: 'Etapas Plan', highlight: true },
          { label: 'Etapas Real', highlight: true },
          { label: 'Δ Etapas' },
          { label: 'Estado' },
          { label: 'Causa' },
        ],
        rows: [
          [
            { text: '3.364 – 6.365' },
            { text: '3.354 – 5.264' },
            { text: '−1.900', delta: 'neg' },
            { text: '17' },
            { text: '10' },
            { text: '−7', delta: 'neg' },
            { badge: { label: 'Desvío', state: 'desvio' } },
            { text: 'Restricción / deformación', muted: true },
          ],
        ],
      },
    },
    {
      key: 'fractura',
      title: 'Fractura',
      dotColor: 'violet',
      table: {
        columns: [
          { label: 'Variable' },
          { label: 'Plan', highlight: true },
          { label: 'Real', highlight: true },
          { label: 'Δ' },
          { label: 'Estado' },
          { label: 'Causa' },
        ],
        rows: [
          [
            { text: 'Presión máx. (psi)' },
            { text: '9.500' },
            { text: '9.850', subtext: 'mín 9.400 – máx 10.120' },
            { text: '+3,7%', delta: 'pos' },
            { badge: { label: 'OK', state: 'ok' } },
            { text: '—', muted: true },
          ],
          [
            { text: 'Concentración arena (sk)' },
            { text: '4.200' },
            { text: '3.350' },
            { text: '−20,2%', delta: 'neg' },
            { badge: { label: 'Desvío', state: 'desvio' } },
            { text: 'Etapas no completadas', muted: true },
          ],
          [
            { text: 'Intensidad arena (Lbs/ft)' },
            { text: '2.100' },
            { text: '1.870', subtext: 'mín 1.680 – máx 2.050' },
            { text: '−11,0%', delta: 'neg' },
            { badge: { label: 'Desvío', state: 'desvio' } },
            { text: 'Restricción de formación', muted: true },
          ],
          [
            { text: 'Caudal (bpm)' },
            { text: '65' },
            { text: '59', subtext: 'mín 52 – máx 64' },
            { text: '−9,2%', delta: 'neg' },
            { badge: { label: 'Desvío', state: 'desvio' } },
            { text: '—', muted: true },
          ],
        ],
      },
    },
  ],
};
